import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialGroupFinanceState: Dtos.GroupFinance & IRegistrationFormState = {
    id: null,
    groupId: null,
    group: null,
    bctInvoicingPrefix: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    fundingEmailAddress: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IGroupFinanceReduxFormState {
    id: IFieldState<number>,
    groupId: IFieldState<number>,
    group: IFieldState<Dtos.Group>,
    bctInvoicingPrefix: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCodeId: IFieldState<number>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    fundingEmailAddress: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
